import React from 'react';
import './App.css';
import Header from './Header';
import { useAuth } from './AuthContext';
import AppRoutes from "./Routes";

function App({ onError }) {
    const { authToken, logout, loading } = useAuth();



    const handleLogout = () => {
        logout();
        window.location.reload();
    };

    if (loading) return null;

    return (
        <div className="App relative ">
            <Header
                authToken={authToken}
                handleLogout={handleLogout} />
            <AppRoutes />
        </div>
    );
}

export default App;